import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Commodity.css";
import { FaCheck } from "react-icons/fa";

const Commodity = () => {
    useEffect(() => {
        // Prevent duplicate script insertion
        if (document.querySelector("#tradingview-widget-script")) return;

        // Create script element
        const script = document.createElement("script");
        script.id = "tradingview-widget-script"; // Unique ID to prevent duplication
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
        script.async = true;
        script.innerHTML = JSON.stringify({
            "colorTheme": "light",
            "dateRange": "12M",
            "showChart": true,
            "locale": "en",
            "largeChartUrl": "",
            "isTransparent": false,
            "showSymbolLogo": true,
            "showFloatingTooltip": false,
            "width": "1000",
            "height": "550",
            "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
            "plotLineColorFalling": "rgba(41, 98, 255, 1)",
            "gridLineColor": "rgba(240, 243, 250, 0)",
            "scaleFontColor": "rgba(19, 23, 34, 1)",
            "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
            "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
            "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
            "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
            "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
            "tabs": [
                {
                    "title": "Commodities",
                    "symbols": [
                        { "s": "CAPITALCOM:GOLD", "d": "Gold" },
                        { "s": "CAPITALCOM:SILVER", "d": "Silver" },
                        { "s": "CAPITALCOM:COPPER", "d": "Copper" },
                        { "s": "CAPITALCOM:CORN", "d": "Corn" },
                        { "s": "CAPITALCOM:PLATINUM", "d": "Platinum" }
                    ],
                    "originalTitle": "Commodities"
                }
            ]
        });

        // Append script to the widget container
        document.querySelector(".tradingview-widget-container").appendChild(script);
    }, []);

    return (
        <>
            <Navbar />

            <div className="forex-section">
                <h2 className="forex-title">Commodities</h2>
            </div>

            <div className="below-hero-section">
                <p>
                    Commodities trading involves buying and selling raw materials like gold, oil, natural gas, and agricultural products. This type of trading allows investors to diversify their portfolios and hedge against inflation. Commodities markets are influenced by global supply and demand, geopolitical events, and economic indicators. Traders can participate through futures contracts, options, and spot trading, leveraging market movements to capitalize on price fluctuations. Whether you’re a seasoned investor or a newcomer, commodities trading offers a dynamic and potentially lucrative opportunity in the financial markets.
                </p>
            </div>

            <div className="below-hero-section2">
                <h2>Trade Commodities With Us</h2>
                {/* TradingView Widget */}
                <div className="widget-wrapper">
                    <div className="tradingview-widget-container">
                        <div className="tradingview-widget-container__widget"></div>
                        <div className="tradingview-widget-copyright">
                            <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank"></a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Four-Column Section with Icons Aligned to the Right */}
            <div className="four-column-section">
                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>High leverage, tight spreads</h3>

                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Advanced charting widgets</h3>

                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Responsive, easy-to-use platforms</h3>

                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Smart and friendly support, 5 days a week</h3>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Commodity;
